import { render, staticRenderFns } from "./RcclCheckBox.vue?vue&type=template&id=2296aeb5&scoped=true"
import script from "./RcclCheckBox.vue?vue&type=script&lang=js"
export * from "./RcclCheckBox.vue?vue&type=script&lang=js"
import style0 from "./RcclCheckBox.vue?vue&type=style&index=0&id=2296aeb5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2296aeb5",
  null
  
)

export default component.exports